import { getApiBaseUrl } from "./getApiBaseUrl";

/**
 * ngrok free: interstitial unless requests include this header (XHR/fetch).
 * We attach it to all axios calls when the page or VITE_API_URL is on ngrok.
 * Primul GET la document/HTML fără header poate încă afișa pagina ngrok; după ce
 * aplicația rulează, apelurile API către același tunel includ header-ul.
 *
 * @see https://ngrok.com/docs/http/#request-headers — ngrok-skip-browser-warning
 */
function hostLooksLikeNgrok(hostnameOrUrl: string): boolean {
  const s = hostnameOrUrl.toLowerCase();
  return (
    s.includes("ngrok-free.dev") ||
    s.includes("ngrok-free.app") ||
    s.includes(".ngrok.io") ||
    s.includes("ngrok.app")
  );
}

/** Merge into axios request headers when frontend or API base URL is served via ngrok. */
export function ngrokSkipBrowserWarningHeaders(): Record<string, string> {
  if (typeof window === "undefined") {
    return {};
  }
  const pageHost = window.location.hostname;
  let apiBase = "";
  try {
    apiBase = getApiBaseUrl();
  } catch {
    apiBase = "";
  }
  if (hostLooksLikeNgrok(pageHost) || hostLooksLikeNgrok(apiBase)) {
    return { "ngrok-skip-browser-warning": "true" };
  }
  return {};
}
